define(["lodash","coreUtils"], function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 32);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(0);
var conversionConfig_1 = __webpack_require__(2);
var coreUtils_1 = __webpack_require__(3);
var isMergeVirtualGroup = function (comp) { return _.get(comp, 'componentType') === conversionConfig_1.conversionConfig.VIRTUAL_GROUP_TYPES.MERGE; };
exports.isMergeVirtualGroup = isMergeVirtualGroup;
var isRescaleVirtualGroup = function (comp) { return _.get(comp, 'componentType') === conversionConfig_1.conversionConfig.VIRTUAL_GROUP_TYPES.RESCALE; };
exports.isRescaleVirtualGroup = isRescaleVirtualGroup;
var isVirtualGroup = function (comp) { return isRescaleVirtualGroup(comp) || isMergeVirtualGroup(comp); };
exports.isVirtualGroup = isVirtualGroup;
function isDesktopOnlyComponent(component) {
    return _.get(component, ['conversionData', 'desktopOnly'], false);
}
exports.isDesktopOnlyComponent = isDesktopOnlyComponent;
function isTextComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'text';
}
exports.isTextComponent = isTextComponent;
function isGraphicComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'graphic' || isImageComponent(component);
}
exports.isGraphicComponent = isGraphicComponent;
function isGroupComponent(component) {
    return component && (component.componentType === 'wysiwyg.viewer.components.Group');
}
exports.isGroupComponent = isGroupComponent;
function isColumnsContainerComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'columns';
}
exports.isColumnsContainerComponent = isColumnsContainerComponent;
function isImageComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'photo';
}
exports.isImageComponent = isImageComponent;
function isMasterPage(component) {
    return _.get(component, 'id') === 'masterPage';
}
exports.isMasterPage = isMasterPage;
function shouldStretchToScreenWidth(component) {
    var shouldStretchHorizontally = function (comp) {
        return _.get(comp.conversionData, 'isScreenWidth', false) ||
            _.get(comp.conversionData, 'stretchHorizontally', false) ||
            _.some(comp.components, shouldStretchHorizontally);
    };
    return isSiteSegmentOrPage(component) || shouldStretchHorizontally(component);
}
exports.shouldStretchToScreenWidth = shouldStretchToScreenWidth;
function isScreenWidthComponent(component) {
    return _.get(component.conversionData, 'isScreenWidth', false) || _.some(component.components, isScreenWidthComponent);
}
exports.isScreenWidthComponent = isScreenWidthComponent;
function translateComps(comps, x, y) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    _.forEach(comps, function (comp) {
        comp.layout.x += x;
        comp.layout.y += y;
    });
}
exports.translateComps = translateComps;
function reparentComponent(parent, newChild, index) {
    addComponentsTo(parent, [newChild], index);
    translateComps([newChild], -parent.layout.x, -parent.layout.y);
}
exports.reparentComponent = reparentComponent;
function addComponentsTo(container, components, index) {
    var children = getChildren(container);
    if (!components.length || !children) {
        return;
    }
    index = index !== undefined ? index : children.length;
    children.splice.apply(children, [index, 0].concat(components));
}
exports.addComponentsTo = addComponentsTo;
function removeChildrenFrom(container, componentsToRemove) {
    var children = getChildren(container);
    _.remove(children, function (child) { return _.includes(componentsToRemove, child); });
}
exports.removeChildrenFrom = removeChildrenFrom;
function removeGroup(group, groupParent) {
    if (!isGroupComponent(group)) {
        return;
    }
    var groupIndex = _.findIndex(groupParent.components, { id: group.id });
    _.forEach(group.components.reverse(), function (curGroupedComponent) {
        addComponentsTo(groupParent, [curGroupedComponent], groupIndex);
        translateComps([curGroupedComponent], group.layout.x, group.layout.y);
    });
    _.remove(groupParent.components, group);
}
exports.removeGroup = removeGroup;
function containsComponent(container, componentMatcher) {
    return _.some(getChildren(container), function (child) { return componentMatcher(child) || child && containsComponent(child, componentMatcher); });
}
exports.containsComponent = containsComponent;
function getHeightAccordingToChildren(container, children, enforceShrinkEvenWithNoChildren) {
    if (isMasterPage(container)) {
        return;
    }
    if (!children || (!enforceShrinkEvenWithNoChildren && _.isEmpty(children))) {
        return;
    }
    var lowestChildBottom = _(children)
        .reject(['conversionData.isInvisible', true])
        .reduce(function (lowest, child) { return _.max([lowest, child.layout.y + child.layout.height, 0]); }, 0);
    if (_.get(container, ['conversionData', 'hasTightYMargin']) || _.get(container, ['conversionData', 'hasTightBottomMargin'])) {
        return lowestChildBottom;
    }
    var bottomMargin = shouldStretchToScreenWidth(container) ? conversionConfig_1.conversionConfig.SECTION_MOBILE_MARGIN_Y : conversionConfig_1.conversionConfig.COMPONENT_MOBILE_MARGIN_Y + _.get(container.conversionData, 'borderWidth', 0);
    return lowestChildBottom + bottomMargin;
}
exports.getHeightAccordingToChildren = getHeightAccordingToChildren;
function ensureContainerTightlyWrapsChildren(container, children, enforceShrinkEvenWithNoChildren, defaultMinHeight) {
    if (defaultMinHeight === void 0) { defaultMinHeight = 0; }
    var heightByChildren = getHeightAccordingToChildren(container, children, enforceShrinkEvenWithNoChildren);
    if (_.isNumber(heightByChildren)) {
        var minHeight = _.get(container, ['conversionData', 'minHeight'], defaultMinHeight);
        container.layout.height = Math.max(minHeight, heightByChildren);
    }
}
exports.ensureContainerTightlyWrapsChildren = ensureContainerTightlyWrapsChildren;
function isSiteSegmentOrPage(component) {
    return isPageComponent(component) || isSiteSegment(component);
}
exports.isSiteSegmentOrPage = isSiteSegmentOrPage;
function isPageComponent(component) {
    return component.type === 'Page';
}
exports.isPageComponent = isPageComponent;
function isContainerComponent(component) {
    return component.type === 'Container';
}
exports.isContainerComponent = isContainerComponent;
function isSiteSegment(component) {
    return _.has(component.conversionData, 'siteSegmentRole');
}
exports.isSiteSegment = isSiteSegment;
function extractMobilePage(desktopPage) {
    var mobilePage = coreUtils_1.objectUtils.cloneDeep(desktopPage);
    var childrenPropertyName = _.has(mobilePage, 'components') ? 'components' : 'children';
    return _.set(mobilePage, childrenPropertyName, desktopPage.mobileComponents || []);
}
exports.extractMobilePage = extractMobilePage;
function getComponentByIdFromStructure(componentId, component) {
    if (component.id === componentId) {
        return component;
    }
    var res = null;
    _.find(getChildren(component), function (comp) {
        res = getComponentByIdFromStructure(componentId, comp);
        return res;
    });
    return res;
}
exports.getComponentByIdFromStructure = getComponentByIdFromStructure;
function unifyGroups(groups, groupOverflowThreshold) {
    if (groups.length > groupOverflowThreshold) {
        groups.length = 0;
        return;
    }
    var haveCommonElements = function (arr1, arr2) { return _.size(_.intersection(arr1, arr2)) > 0; };
    var _loop_1 = function (i) {
        var j = _.findLastIndex(groups, function (group, index) { return index < i && haveCommonElements(groups[i], group); });
        if (j !== -1) {
            groups[j] = groups[j].concat(_.difference(groups[i], groups[j]));
            groups.splice(i, 1);
        }
    };
    for (var i = groups.length - 1; i >= 0; i--) {
        _loop_1(i);
    }
}
exports.unifyGroups = unifyGroups;
function getComponentsByIds(container, compIds) {
    var children = getChildren(container);
    return _.map(compIds, function (id) { return _.find(children, { id: id }) || null; });
}
exports.getComponentsByIds = getComponentsByIds;
function getParent(componentId, root) {
    var children = getChildren(root);
    if (_.find(children, { id: componentId })) {
        return root;
    }
    var parent = null;
    _.find(children, function (child) {
        parent = getParent(componentId, child);
        return parent;
    });
    return parent;
}
exports.getParent = getParent;
function getSnugLayout(components) {
    if (!components || components.length === 0) {
        return undefined;
    }
    var mostLeft = _.min(_.map(components, 'layout.x'));
    var mostTop = _.min(_.map(components, 'layout.y'));
    var mostRight = _.max(_.map(components, function (c) { return c.layout.x + c.layout.width; }));
    var mostBottom = _.max(_.map(components, function (c) { return c.layout.y + c.layout.height; }));
    return {
        x: mostLeft,
        y: mostTop,
        width: mostRight - mostLeft,
        height: mostBottom - mostTop,
        rotationInDegrees: 0
    };
}
exports.getSnugLayout = getSnugLayout;
function getTinyMenuDefaultPosition() {
    return {
        x: conversionConfig_1.conversionConfig.MOBILE_WIDTH - (conversionConfig_1.conversionConfig.TINY_MENU_SIZE + conversionConfig_1.conversionConfig.SITE_SEGMENT_PADDING_X),
        y: conversionConfig_1.conversionConfig.SECTION_MOBILE_MARGIN_Y,
        rotationInDegrees: 0
    };
}
exports.getTinyMenuDefaultPosition = getTinyMenuDefaultPosition;
function getChildren(comp) {
    return comp.components || comp.children;
}
exports.getChildren = getChildren;
function getRangesOverlap(range1, range2) {
    if (range1 === void 0) { range1 = []; }
    if (range2 === void 0) { range2 = []; }
    var getSortedRangesOverlap = function (r1, r2) { return Math.min(r1[1], r2[1]) - r2[0]; };
    return range1[0] <= range2[0] ? getSortedRangesOverlap(range1, range2) : getSortedRangesOverlap(range2, range1);
}
exports.getRangesOverlap = getRangesOverlap;
function getYOverlap(comp1, comp2) {
    var getYProjection = function (comp) { return [comp.layout.y, comp.layout.height + comp.layout.y]; };
    return getRangesOverlap(getYProjection(comp1), getYProjection(comp2));
}
exports.getYOverlap = getYOverlap;
function getXOverlap(comp1, comp2) {
    if (isScreenWidthComponent(comp1)) {
        return comp2.layout.width;
    }
    if (isScreenWidthComponent(comp2)) {
        return comp1.layout.width;
    }
    var getXProjection = function (comp) { return [comp.layout.x, comp.layout.width + comp.layout.x]; };
    return getRangesOverlap(getXProjection(comp1), getXProjection(comp2));
}
exports.getXOverlap = getXOverlap;
var getArea = function (component) { return component.layout.width * component.layout.height; };
function hasGreaterArea(comp1, comp2) {
    if (isScreenWidthComponent(comp1)) {
        return comp1.layout.height >= comp2.layout.height || getArea(comp1) > getArea(comp2);
    }
    if (isScreenWidthComponent(comp2)) {
        return false;
    }
    return getArea(comp1) > getArea(comp2);
}
exports.hasGreaterArea = hasGreaterArea;
function haveSufficientOverlap(comp1, comp2, overlapToMinAreaRationThreshold) {
    var xOverlap = getXOverlap(comp1, comp2);
    var yOverlap = getYOverlap(comp1, comp2);
    if (xOverlap <= 0 || yOverlap <= 0) {
        return false;
    }
    var overlapArea = xOverlap * yOverlap;
    var minCompArea = Math.min(getArea(comp1), getArea(comp2));
    return overlapArea > 0 && overlapArea / minCompArea >= overlapToMinAreaRationThreshold;
}
exports.haveSufficientOverlap = haveSufficientOverlap;
function isEmptyContainer(component) {
    if (!isContainerComponent(component)) {
        return false;
    }
    if (component.conversionData.category === 'columns') {
        return _.size(component.components) === 1 && _.isEmpty(component.components[0].components);
    }
    return _.isEmpty(component.components);
}
exports.isEmptyContainer = isEmptyContainer;
function shouldReparentCompToChildOfContainer(comp, container) {
    return isColumnsContainerComponent(container) && _.get(comp, ['conversionData', 'isInvisible'], false);
}
exports.shouldReparentCompToChildOfContainer = shouldReparentCompToChildOfContainer;
function getAllCompsInStructure(compStructure, isMobile, filterFunc) {
    if (isMobile === void 0) { isMobile = false; }
    var queue = [[compStructure]];
    for (var index = 0; index < queue.length; index++) {
        var innerQueue = queue[index];
        _.forEach(innerQueue, function (child) {
            var children = isMobile ? _.get(child, 'mobileComponents') : getChildren(child);
            if (!_.isEmpty(children)) {
                queue.push(children);
            }
        });
    }
    return _(queue).flatten().remove(filterFunc).keyBy('id').value();
}
exports.getAllCompsInStructure = getAllCompsInStructure;


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(0);
var sweepSortAnalyzer = __webpack_require__(8);
var conversionUtils = __webpack_require__(1);
function splitToFragments(siblings, axis) {
    var sweepLineEvents = sweepSortAnalyzer.createEventsQueue(siblings, axis);
    return sweepSortAnalyzer.createFragments(sweepLineEvents);
}
exports.splitToFragments = splitToFragments;
function sortSiblings(components) {
    if (_.size(components) <= 1) {
        return components;
    }
    var rowsComponents = _.map(splitToFragments(components, 'y'), 'comps');
    return _.reduce(rowsComponents, function (sortedComponents, rowComponents) {
        if (_.size(rowComponents) === 1) {
            return sortedComponents.concat(rowComponents);
        }
        var columnsComponents = _.map(splitToFragments(rowComponents, 'x'), 'comps');
        var sortedColumnsComponents = _.flatMap(columnsComponents, function (columnComponents) {
            return _.size(columnComponents) === 1 ? columnComponents : _.sortBy(columnComponents, _.findIndex.bind(null, components));
        });
        return sortedComponents.concat(sortedColumnsComponents);
    }, []);
}
exports.sortSiblings = sortSiblings;
function getComponentsOrder(parent) {
    var children = conversionUtils.getChildren(parent);
    if (!children) {
        return {};
    }
    var sortedChildren = sortSiblings(children);
    var parentOrderMap = _.set({}, parent.id, _.map(sortedChildren, 'id'));
    var childrenOrderMaps = _.map(children, getComponentsOrder);
    return _.assign.apply(_, [parentOrderMap].concat(childrenOrderMaps));
}
exports.getComponentsOrder = getComponentsOrder;


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var conversionConfig = {
    MOBILE_WIDTH: 320,
    MARGIN_BETWEEN_TEXT_AND_NON_TEXT: 20,
    COMPONENT_MOBILE_MARGIN_X: 10,
    COMPONENT_MOBILE_MARGIN_Y: 10,
    SECTION_MOBILE_MARGIN_Y: 20,
    SITE_SEGMENT_PADDING_X: 20,
    TINY_MENU_SIZE: 50,
    TEXT_MAX_LENGTH_FOR_RESCALING: 25,
    MIN_WIDTH_FOR_ENLARGE: 140,
    DEFAULT_TEXT_HEIGHT: 10,
    VIRTUAL_GROUP_TYPES: {
        RESCALE: 'RESCALE_VIRTUAL_GROUP',
        MERGE: 'MERGE_VIRTUAL_GROUP'
    }
};
exports.conversionConfig = conversionConfig;


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var conversionUtils = __webpack_require__(1);
var sortingUtils = __webpack_require__(18);
var mobileLayoutUtils = {
    translateComponents: conversionUtils.translateComps,
    getSnugLayout: conversionUtils.getSnugLayout,
    splitToFragments: sortingUtils.splitToFragments,
    sortSiblings: sortingUtils.sortSiblings,
    getComponentsOrder: sortingUtils.getComponentsOrder
};
module.exports = mobileLayoutUtils;


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(0);
var conversionUtils = __webpack_require__(1);
var EQUALITY_DEVIATION_THRESHOLD = 0.1;
var getSign = function (n) { return n === 0 ? 0 : n / Math.abs(n); };
exports.getSign = getSign;
var getComponentSize = function (comp, dim) { return dim === 'x' ? comp.layout.width : comp.layout.height; };
exports.getComponentSize = getComponentSize;
var getComponentEndCoordinate = function (comp, axis) { return comp.layout[axis] + getComponentSize(comp, axis); };
exports.getComponentEndCoordinate = getComponentEndCoordinate;
var compareComponentsByY = function (c1, c2) { return getSign(c1.layout.y - c2.layout.y); };
exports.compareComponentsByY = compareComponentsByY;
function haveSimilarCoordinates(comp1, comp2, dim, deviationThreshold) {
    if (deviationThreshold === void 0) { deviationThreshold = EQUALITY_DEVIATION_THRESHOLD; }
    var v1 = _.get(comp1, ['layout', dim]);
    var v2 = _.get(comp2, ['layout', dim]);
    return Math.abs(v1 - v2) <= deviationThreshold * _.min([getComponentSize(comp1, dim), getComponentSize(comp2, dim)]);
}
function similarBy(comp1, comp2, valuePath, deviationThreshold) {
    if (deviationThreshold === void 0) { deviationThreshold = EQUALITY_DEVIATION_THRESHOLD; }
    var v1 = _.get(comp1, valuePath);
    var v2 = _.get(comp2, valuePath);
    return Math.abs(v1 - v2) <= deviationThreshold * _.min([v1, v2]);
}
function areSimilarFragments(fragment1, fragment2, dimension) {
    if (fragment1 === fragment2) {
        return true;
    }
    if (_.size(fragment1) !== _.size(fragment2) || shouldBreakFragment(fragment1, dimension) || shouldBreakFragment(fragment2, dimension)) {
        return false;
    }
    return _.every(fragment1, function (comp1, compIndex) {
        var comp2 = fragment2[compIndex];
        return comp1.componentType === comp2.componentType && haveSimilarCoordinates(comp1, comp2, dimension) &&
            (comp1.conversionData.category === 'text' ? similarBy(comp1, comp2, ['conversionData', 'averageNormalizedFontSize']) :
                similarBy(comp1, comp2, ['layout', 'height']) && similarBy(comp1, comp2, ['layout', 'width']));
    });
}
exports.areSimilarFragments = areSimilarFragments;
function shouldBreakFragment(fragment, dimension) {
    var firstDistantCompIndex = _.findIndex(fragment, function (comp, compIndex) {
        if (compIndex === 0) {
            return false;
        }
        var previousCompEnd = getComponentEndCoordinate(fragment[compIndex - 1], dimension);
        var distance = comp.layout[dimension] - previousCompEnd;
        return distance < 0 || distance > _.min([getComponentSize(fragment[compIndex - 1], dimension), getComponentSize(comp, dimension)]);
    });
    return firstDistantCompIndex !== -1 && firstDistantCompIndex !== fragment.length - 1;
}
function getOrderedComponents(parent) {
    var children = conversionUtils.getChildren(parent);
    return _.map(parent.conversionData.componentsOrder, function (id) { return _.find(children, { id: id }); });
}
exports.getOrderedComponents = getOrderedComponents;
var shouldUseNaturalOrder = function (comp) {
    return conversionUtils.isRescaleVirtualGroup(comp) && comp.conversionData.rescaleMethod !== 'reorder' ||
        comp.conversionData.structuralContainer;
};
exports.shouldUseNaturalOrder = shouldUseNaturalOrder;
function sortComponentsByNaturalOrder(parent, comps) {
    var childrenIds = _.map(conversionUtils.getChildren(parent), 'id');
    return _.sortBy(comps, function (comp) { return childrenIds.indexOf(comp.id); });
}
exports.sortComponentsByNaturalOrder = sortComponentsByNaturalOrder;
function hasMobileHintsPresets(comp) {
    var mobileHints = _.pick(comp.conversionData.mobileHints, ['recommendedWidth', 'recommendedHeight', 'recommendedScale', 'recommendedOrder']);
    return !_.isEmpty(mobileHints);
}
exports.hasMobileHintsPresets = hasMobileHintsPresets;


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _ = __webpack_require__(0);
var analyzerUtils_1 = __webpack_require__(4);
var coreUtils_1 = __webpack_require__(3);
var EVENTS_TYPES = {
    START_EVENT: 'start',
    END_EVENT: 'end'
};
var COMPONENT_SIZE_SCALE_FACTOR = 0.9;
var DISTANCE_PARTITIONS_WEIGHTS = {
    HORIZONTAL: 1,
    VERTICAL: 1.25
};
function findVerticalDividerFragmentIndex(fragments, allEvents) {
    var eventsCoordinates = _(allEvents.y).partition({ eventType: EVENTS_TYPES.START_EVENT }).map(function (a) { return _.map(a, 'coordinate'); }).value();
    var maxStart = _.max(eventsCoordinates[0]);
    var minEnd = _.min(eventsCoordinates[1]);
    return _.findIndex(fragments, function (fragment) {
        var firstComp = fragment.comps[0];
        return fragment.comps.length === 1 && firstComp.conversionData.keepIfVerticalDivider &&
            firstComp.layout.y <= minEnd && analyzerUtils_1.getComponentEndCoordinate(firstComp, 'y') >= maxStart;
    });
}
function refragment(fragments, getNewFragmentIndex) {
    return _.transform(fragments, function (res, fragment, fragmentIndex) {
        var newFragmentIndex = getNewFragmentIndex(fragmentIndex);
        res[newFragmentIndex] = res[newFragmentIndex] || { comps: [], distanceToPreviousFragment: fragment.distanceToPreviousFragment };
        res[newFragmentIndex].comps = res[newFragmentIndex].comps.concat(fragment.comps);
        return res;
    }, []);
}
var strategiesHandlers = {
    singleCompRow: function (fragments, allEvents, partitionAxis) {
        if (partitionAxis === 'x') {
            return null;
        }
        var singleCompRowIndex = _.findIndex(fragments, function (fragment) { return _.size(fragment.comps) === 1; });
        if (singleCompRowIndex === -1) {
            return null;
        }
        var getNewFragmentIndex = function (oldFragmentIndex) { return analyzerUtils_1.getSign(oldFragmentIndex - singleCompRowIndex) + analyzerUtils_1.getSign(singleCompRowIndex); };
        var newFragments = refragment(fragments, getNewFragmentIndex);
        return { type: 'singleCompRow', fragments: newFragments, fragmentsEvents: splitAllEventsByFragments(allEvents, newFragments) };
    },
    verticalDivider: function (fragments, allEvents, partitionAxis) {
        var isSingleCompFragment = function (fragment) { return _.size(fragment.comps) === 1; };
        if (_.size(fragments) < 3 || _.every(fragments, isSingleCompFragment) || partitionAxis === 'y') {
            return null;
        }
        var dividerFragmentIndex = findVerticalDividerFragmentIndex(fragments, allEvents);
        if (dividerFragmentIndex === -1) {
            return null;
        }
        _.set(fragments[dividerFragmentIndex].comps[0], ['conversionData', 'isVerticalDivider'], true);
        var getNewFragmentIndex = function (oldFragmentIndex) { return analyzerUtils_1.getSign(oldFragmentIndex - dividerFragmentIndex) + analyzerUtils_1.getSign(dividerFragmentIndex); };
        var newFragments = refragment(fragments, getNewFragmentIndex);
        return { type: 'verticalDivider', fragments: newFragments, fragmentsEvents: splitAllEventsByFragments(allEvents, newFragments) };
    },
    mirrorPattern: function (fragments, allEvents, partitionAxis) {
        if (_.size(fragments) < 2) {
            return null;
        }
        var fragmentsEvents = splitAllEventsByFragments(allEvents, fragments);
        var perpAxis = getPerpendicularAxis(partitionAxis);
        var sortedFragmentsComps = _.map(fragmentsEvents, function (fragmentEvents) { return extractCompsFromEvents(fragmentEvents[perpAxis]); });
        var isMirrorPattern = _.every(sortedFragmentsComps, function (fragmentComps) { return analyzerUtils_1.areSimilarFragments(fragmentComps, sortedFragmentsComps[0], perpAxis); });
        if (!isMirrorPattern) {
            return null;
        }
        return isMirrorPattern ? createSingleFragmentPartition(_.flatten(sortedFragmentsComps), allEvents, { type: 'mirrorPattern' }) : null;
    },
    chessPattern: function (fragments, allEvents, partitionAxis) {
        var isValidFragmentSize = function (fragment) { return _.size(fragment.comps) === 2; };
        if (partitionAxis !== 'y' || _.size(fragments) < 2 || !_.every(fragments, isValidFragmentSize)) {
            return null;
        }
        var fragmentsEvents = splitAllEventsByFragments(allEvents, fragments);
        var xSortedFragmentsComps = _.map(fragmentsEvents, function (fragmentEvents) { return extractCompsFromEvents(fragmentEvents.x); });
        var chessSortedComps = _.flatMap(xSortedFragmentsComps, function (fragmentComps, fragmentIndex) { return isEven(fragmentIndex) ? fragmentComps : _.reverse(fragmentComps); });
        var evenCategory = chessSortedComps[0].conversionData.category;
        var oddCategory = evenCategory === 'text' ? 'photo' : 'text';
        var isValidChessComp = function (comp, compIndex) { return comp.conversionData.category === (isEven(compIndex) ? evenCategory : oddCategory); };
        var isChessPattern = _.every(chessSortedComps, isValidChessComp);
        return isChessPattern ? createSingleFragmentPartition(chessSortedComps, allEvents, { type: 'chessPattern' }) : null;
    }
};
var extractCompsFromEvents = function (events) { return _(events).map('compRef').uniq().value(); };
exports.extractCompsFromEvents = extractCompsFromEvents;
var getPerpendicularAxis = function (axis) { return axis === 'x' ? 'y' : 'x'; };
var isEven = function (n) { return n % 2 === 0; };
function createSingleFragmentPartition(sortedComps, allEvents, partitionData) {
    return _.assign(partitionData, { fragments: [{ comps: sortedComps, distanceToPreviousFragment: -1 }], fragmentsEvents: [allEvents] });
}
function compareEvents(event1, event2) {
    var distance = event1.coordinate - event2.coordinate;
    if (distance !== 0) {
        return analyzerUtils_1.getSign(distance);
    }
    if (event1.compRef === event2.compRef) {
        return event1.eventType === EVENTS_TYPES.END_EVENT ? 1 : -1;
    }
    return event1.eventType === EVENTS_TYPES.END_EVENT ? -1 : 1;
}
function insertStable(arr, event) {
    var i = _.findLastIndex(arr, function (e) {
        if (e.coordinate === event.coordinate) {
            if (e.eventType === EVENTS_TYPES.START_EVENT && event.eventType === EVENTS_TYPES.START_EVENT) {
                return e.size > event.size;
            }
            if (e.eventType === EVENTS_TYPES.END_EVENT && event.eventType === EVENTS_TYPES.END_EVENT) {
                return e.size < event.size;
            }
            if (e.eventType === EVENTS_TYPES.START_EVENT && event.eventType === EVENTS_TYPES.END_EVENT) {
                return e.compRef === event.compRef;
            }
            if (e.eventType === EVENTS_TYPES.END_EVENT && event.eventType === EVENTS_TYPES.START_EVENT) {
                return e.compRef !== event.compRef;
            }
        }
        return e.coordinate < event.coordinate;
    });
    arr.splice(i + 1, 0, event);
    return arr;
}
function createEventsQueue(comps, axis) {
    var events = _.transform(comps, function (eventsQueue, comp) {
        var componentStartPosition = comp.layout[axis] || 0;
        var componentEndPosition = analyzerUtils_1.getComponentEndCoordinate(comp, axis) || componentStartPosition;
        var componentSize = analyzerUtils_1.getComponentSize(comp, axis) || 0;
        insertStable(eventsQueue, { eventType: EVENTS_TYPES.START_EVENT, compRef: comp, coordinate: componentStartPosition, size: componentSize });
        insertStable(eventsQueue, { eventType: EVENTS_TYPES.END_EVENT, compRef: comp, coordinate: componentEndPosition, size: componentSize });
        return eventsQueue;
    }, []);
    return _.map(events, function (event) { return _.omit(event, 'size'); });
}
exports.createEventsQueue = createEventsQueue;
function createFragments(sweepLineEvents) {
    var sweepLineStatus = [];
    var fragments = [];
    _.forEach(sweepLineEvents, function (event) {
        var lastFragment = _.last(fragments);
        if (event.eventType === EVENTS_TYPES.START_EVENT) {
            if (_.isEmpty(sweepLineStatus)) {
                var distance = lastFragment ? event.coordinate - _.last(lastFragment.events).coordinate : -1;
                var newFragment = { events: [event], distanceToPreviousFragment: distance };
                fragments.push(newFragment);
            }
            else {
                lastFragment.events.push(event);
            }
            sweepLineStatus.push(event);
        }
        else {
            _.remove(sweepLineStatus, { compRef: event.compRef });
            lastFragment.events.push(event);
        }
    });
    return _.map(fragments, function (group) {
        return { comps: extractCompsFromEvents(group.events), distanceToPreviousFragment: group.distanceToPreviousFragment };
    });
}
exports.createFragments = createFragments;
function divideByDistance(fragments, allEvents, partitionAxis) {
    var mostDistantFragment = _.maxBy(fragments, 'distanceToPreviousFragment');
    var mostDistantFragmentIndex = _.findIndex(fragments, mostDistantFragment);
    var getNewFragmentIndex = function (oldFragmentIndex) { return oldFragmentIndex < mostDistantFragmentIndex ? 0 : 1; };
    var newFragments = refragment(fragments, getNewFragmentIndex);
    var adjacentFragments = [fragments[mostDistantFragmentIndex - 1], mostDistantFragment];
    var adjacentFragmentsEvents = _.filter(allEvents[getPerpendicularAxis(partitionAxis)], function (e) { return _.some(adjacentFragments, function (g) { return _.includes(g.comps, e.compRef); }); });
    var partition = { fragmentsEvents: splitAllEventsByFragments(allEvents, newFragments), fragments: newFragments };
    var maxCompsDistance = calculateMaxCompsDistance(adjacentFragments, adjacentFragmentsEvents, partitionAxis);
    return _.assign(partition, { maxCompsDistance: maxCompsDistance });
}
function extractPartitionAxisVectors(eventsPartition, axis) {
    return _(eventsPartition)
        .map(function (events, vectorIndex) {
        return (vectorIndex ?
            _.map(events, function (e) { return _.defaults({ closestPoint: e.compRef.layout[axis] }, e); }) :
            _.map(events, function (e) { return _.defaults({ closestPoint: analyzerUtils_1.getComponentEndCoordinate(e.compRef, axis) }, e); }));
    })
        .map(function (events, vectorIndex) {
        return _.reduce(events, function (vector, e) {
            var lastAddedEvent = _.last(vector);
            if (!lastAddedEvent || lastAddedEvent.eventType === EVENTS_TYPES.END_EVENT) {
                return vector.concat(e.eventType === EVENTS_TYPES.START_EVENT ? [e] : []);
            }
            if (lastAddedEvent.compRef === e.compRef) {
                return vector.concat([e]);
            }
            if (vectorIndex && e.closestPoint < lastAddedEvent.closestPoint || !vectorIndex && e.closestPoint > lastAddedEvent.closestPoint) {
                vector.splice(vector.length - 1, 1, e);
            }
            return vector;
        }, []);
    })
        .value();
}
function calculateMaxCompsDistance(fragments, fragmentsEvents, axis) {
    var eventsPartition = _.partition(fragmentsEvents, function (e) { return _.includes(fragments[0].comps, e.compRef); });
    var events = extractPartitionAxisVectors(eventsPartition, axis);
    var eventIndex = [0, 0];
    var sweepLineStatus = [[], []];
    function getNextEventFragmentIndex() {
        if (eventIndex[0] === events[0].length || eventIndex[1] === events[1].length) {
            return eventIndex[0] === events[0].length ? 1 : 0;
        }
        return events[0][eventIndex[0]].coordinate <= events[1][eventIndex[1]].coordinate ? 0 : 1;
    }
    var maxCompsDistances = -Infinity;
    while (eventIndex[0] < events[0].length || eventIndex[1] < events[1].length) {
        var eventFragmentIndex = getNextEventFragmentIndex();
        var event_1 = events[eventFragmentIndex][eventIndex[eventFragmentIndex]++];
        if (event_1.eventType === EVENTS_TYPES.END_EVENT) {
            _.remove(sweepLineStatus[eventFragmentIndex], { compRef: event_1.compRef });
            continue;
        }
        sweepLineStatus[eventFragmentIndex].push(event_1);
        var closestEvents = [_.maxBy(sweepLineStatus[0], 'closestPoint'), _.minBy(sweepLineStatus[1], 'closestPoint')];
        var distanceBetweenClosestEvents = _.get(closestEvents, [1, 'closestPoint']) - _.get(closestEvents, [0, 'closestPoint']);
        if (!_.isNaN(distanceBetweenClosestEvents) && distanceBetweenClosestEvents > maxCompsDistances) {
            maxCompsDistances = distanceBetweenClosestEvents;
        }
    }
    return maxCompsDistances;
}
function splitAxisEventsByFragments(events, fragments) {
    return _.transform(events, function (res, event) {
        var eventFragmentIndex = _.findIndex(fragments, function (group) { return _.includes(group.comps, event.compRef); });
        res[eventFragmentIndex] = (res[eventFragmentIndex] || []).concat([event]);
        return res;
    }, []);
}
exports.splitAxisEventsByFragments = splitAxisEventsByFragments;
function splitAllEventsByFragments(allEvents, fragments) {
    var xEventsPartition = splitAxisEventsByFragments(allEvents.x, fragments);
    var yEventsPartition = splitAxisEventsByFragments(allEvents.y, fragments);
    return _.map(_.keys(fragments), function (index) { return _.assign({}, { x: xEventsPartition[index], y: yEventsPartition[index] }); });
}
function findBestPartitionByStrategy(allEvents, fragments, strategies) {
    var bestPartition = null;
    _.forEach(strategiesHandlers, function (handler, strategyName) {
        if (!strategies[strategyName]) {
            return true;
        }
        var bestPartitionY = handler(fragments.y, allEvents, 'y');
        var bestPartitionX = handler(fragments.x, allEvents, 'x');
        bestPartition = bestPartitionY && bestPartitionX ? null : bestPartitionY || bestPartitionX;
        return bestPartition === null;
    });
    return bestPartition;
}
function findBestDistancePartition(allEvents, fragments) {
    var partitionX = _.size(fragments.x) > 1 ? divideByDistance(fragments.x, allEvents, 'x') : null;
    var partitionY = _.size(fragments.y) > 1 ? divideByDistance(fragments.y, allEvents, 'y') : null;
    if (partitionX && partitionY) {
        var bestDistancePartition = DISTANCE_PARTITIONS_WEIGHTS.HORIZONTAL * partitionX.maxCompsDistance > DISTANCE_PARTITIONS_WEIGHTS.VERTICAL * partitionY.maxCompsDistance ? partitionX : partitionY;
        return _.pick(bestDistancePartition, ['fragments', 'fragmentsEvents']);
    }
    return partitionX || partitionY;
}
function findBestPartition(allEvents, fragments, strategies) {
    return findBestPartitionByStrategy(allEvents, fragments, strategies) || findBestDistancePartition(allEvents, fragments);
}
function getSortedOverlappingComponents(parent, comps) {
    comps = analyzerUtils_1.sortComponentsByNaturalOrder(parent, comps);
    comps = _.sortBy(comps, 'layout.y');
    var overlayGroupId = "overlayGroup_" + comps[0].id;
    _.forEach(comps, function (comp) { return _.set(comp, ['conversionData', 'overlayGroupId'], overlayGroupId); });
    return comps;
}
function getSortedComponents(parent, comps, allEvents, settings) {
    if (_.size(comps) < 2) {
        return comps || [];
    }
    var fragments = _.mapValues(allEvents, createFragments);
    if (_.size(fragments.x) === 1 && _.size(fragments.y) === 1) {
        return settings.detectSemanticGroups && settings.useOverlapRules ? getSortedOverlappingComponents(parent, comps) :
            getSortedOverlappingComponentsOld(parent, comps, settings);
    }
    var partition = findBestPartition(allEvents, fragments, { mirrorPattern: true, verticalDivider: true, chessPattern: true, singleCompRow: true });
    return _.size(partition.fragments) === 1 ? partition.fragments[0].comps :
        _.flatMap(partition.fragments, function (fragment, fragmentIndex) { return getSortedComponents(parent, fragment.comps, partition.fragmentsEvents[fragmentIndex], settings); });
}
function getSortedOverlappingComponentsOld(parent, comps, settings) {
    var haveTransformedLayout = function (compsList) { return _.some(compsList, 'conversionData.originalLayout'); };
    var isLayoutTransformed = haveTransformedLayout(comps) || _.some(comps, function (child) { return haveTransformedLayout(child); });
    if (isLayoutTransformed) {
        restoreLayouts(comps);
        return comps;
    }
    transformLayouts(comps);
    var eventsY = createEventsQueue(comps, 'y');
    var eventsX = createEventsQueue(comps, 'x');
    var orderedComps = getSortedComponents(parent, comps, { y: eventsY, x: eventsX }, settings);
    restoreLayouts(orderedComps);
    return orderedComps;
}
function transformLayouts(comps) {
    _.forEach(comps, function (comp) {
        var originalLayout = comp.layout;
        var transformedLayout = _.assign(coreUtils_1.objectUtils.cloneDeep(originalLayout), {
            height: originalLayout.height * COMPONENT_SIZE_SCALE_FACTOR,
            width: originalLayout.width * COMPONENT_SIZE_SCALE_FACTOR
        });
        comp.layout = transformedLayout;
        _.set(comp, ['conversionData', 'originalLayout'], originalLayout);
    });
}
function restoreLayouts(comps, recursive) {
    if (recursive === void 0) { recursive = true; }
    _.forEach(comps, function (comp) {
        var originalLayout = _.get(comp, ['conversionData', 'originalLayout']);
        if (originalLayout) {
            comp.layout = coreUtils_1.objectUtils.cloneDeep(originalLayout);
            delete comp.conversionData.originalLayout;
        }
    });
    if (recursive) {
        _.forEach(comps, function (comp) { return restoreLayouts(comp.components, false); });
    }
}
function setComponentsOrder(parent, comps, settings) {
    var eventsY = createEventsQueue(comps, 'y');
    var eventsX = createEventsQueue(comps, 'x');
    var orderedComponents = getSortedComponents(parent, comps, { y: eventsY, x: eventsX }, settings);
    parent.conversionData.componentsOrder = _.map(orderedComponents, 'id');
}
exports.setComponentsOrder = setComponentsOrder;
var testAPI = {
    isEven: isEven,
    transformLayouts: transformLayouts,
    restoreLayouts: restoreLayouts,
    extractCompsFromEvents: extractCompsFromEvents,
    getPerpendicularAxis: getPerpendicularAxis,
    compareEvents: compareEvents,
    refragment: refragment,
    splitAxisEventsByFragments: splitAxisEventsByFragments,
    splitAllEventsByFragments: splitAllEventsByFragments,
    calculateMaxCompsDistance: calculateMaxCompsDistance,
    sortComponentsByNaturalOrder: analyzerUtils_1.sortComponentsByNaturalOrder
};
exports.testAPI = testAPI;


/***/ })

/******/ })});;


// WEBPACK FOOTER //
// mobileLayoutUtils.js